import React, { useState } from "react";
import type { ReactNode } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type BulkSelectionLayoutProps = {
  children?: ReactNode;
  onToggleBulkSelection?: (_isExpanded: boolean) => void;
  collapsedHeading?: string;
  expandedHeading?: string;
  expandedTitle?: ReactNode;
};

function BulkSelectionLayout({
  children,
  onToggleBulkSelection,
  collapsedHeading = "Want to make bulk selections",
  expandedHeading = "",
  expandedTitle,
}: BulkSelectionLayoutProps) {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleOnExpand =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
      onToggleBulkSelection?.(!!isExpanded);
    };

  const shouldExpandIt = (panel: string) => expanded === panel;

  return (
    <div>
      <Accordion
        expanded={shouldExpandIt("bulkSelection")}
        onChange={handleOnExpand("bulkSelection")}
        className={`flex-grow-1`}
        elevation={2}
        sx={(theme) => ({
          border: `1px solid ${theme.palette.primary.main}`,
          filter: "none",
        })}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon
              sx={{ color: (theme) => theme.palette.primary.main }}
            />
          }
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          {expanded ? (
            <Typography>
              {expandedTitle ? (
                <span className="fw-b">{expandedTitle}</span>
              ) : (
                <>
                  1. Make selections for{" "}
                  <span className="fw-b">{expandedHeading}</span>
                </>
              )}
            </Typography>
          ) : (
            <Typography>
              <Typography
                component="span"
                color="textPrimary"
                className="fw-b mr-1"
              >
                {collapsedHeading}?{" "}
              </Typography>
              <Typography component="span" className="link">
                Click here
              </Typography>
            </Typography>
          )}
        </AccordionSummary>
        <AccordionDetails>{children}</AccordionDetails>
      </Accordion>
    </div>
  );
}

export default BulkSelectionLayout;
